export const USER_INFO = 'USER_INFO';